var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { ofActionDispatched } from '@ngxs/store';
import { MessageEnum } from '../models/message.enum';
import { TakeChapterPicture, TakeChapterPictureSuccess, SetSelectedChapterBackground } from 'src/app/story/state/chapters/story.chapters.actions';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { flatMap, take, catchError, tap } from 'rxjs/operators';
import { of } from 'rxjs/internal/observable/of';
import { BackgroundModel } from 'src/app/engine/models/background.model';
import { ColorUtils } from 'src/app/shared/libraries/colors/colors';
import { ViewActions } from 'src/app/view/state/view.actions';
import { ViewState } from 'src/app/view/state/view.state';
import { WidgetWiring } from 'src/app/shared/widget-wiring';
import { isEmpty } from 'lodash';
import { SetScrollMode } from 'src/app/engine/state/engine.actions';
function toAPIColor(input) {
    var colors = input.colors, gradientType = input.gradientType, colorStops = input.colorStops;
    return {
        // normalize: [] -> [[]]
        colors: [
            [colors[0], colors[1], colors[2], colors[3]],
            [colors[4], colors[5], colors[6], colors[7]]
        ],
        // as-is
        gradientType: gradientType,
        colorStops: colorStops
    };
}
function normalizeColorInput(input) {
    var paramColorValues = ColorUtils.getColors(input)
        .map(function (parsedColor) { return parsedColor['255']; });
    return paramColorValues;
}
// #TODO[AC]: should be deprecated in the future and handled by the client's code
function openImageInTab(imageData) {
    // iframe needed to bypass data url restriction in window.open
    var imageWindow = window.open('', '_blank');
    if (imageWindow) {
        var imageFrame = imageWindow.document.createElement('iframe');
        imageFrame.src = imageData;
        imageWindow.document.body.style.margin = '0';
        imageFrame.style.border = 'none';
        imageFrame.style.height = '100%';
        imageFrame.style.width = '100%';
        imageWindow.document.body.appendChild(imageFrame);
    }
}
export function getUIEvents() {
    return [];
}
export function getUIProcedures(Human, store, actions, engineService, imageService) {
    return [
        // gets the current chapter's background color
        {
            procName: MessageEnum.UIGetBackground,
            actionFn: function () {
                var background = store.selectSnapshot(StoryChaptersState.getSelectedChapterBackground);
                return toAPIColor(background);
            }
        },
        // sets the current chapter's background color
        {
            procName: MessageEnum.UISetBackground,
            // normalize color values
            mapFnIn: function (params) {
                var colors = params.colors, colorStops = params.colorStops, gradientType = params.gradientType;
                return {
                    // normalize color input
                    colors: colors ? normalizeColorInput(colors) : colors,
                    gradientType: gradientType,
                    colorStops: colorStops
                };
            },
            actionFn: function (params) {
                if (params) {
                    // get current background
                    var currentBackground = store.selectSnapshot(StoryChaptersState.getSelectedChapterBackground);
                    var colors = currentBackground.colors, colorStops = currentBackground.colorStops, gradientType = currentBackground.gradientType;
                    // get optional user configured values, else current
                    var targetColors = params.colors ? [].concat.apply([], __spread(params.colors)) : colors;
                    var targetGradientType = params.gradientType || gradientType;
                    var targetColorStops = params.colorStops || colorStops;
                    // set app background
                    var background = new BackgroundModel(targetColors, targetGradientType, targetColorStops);
                    store.dispatch(new SetSelectedChapterBackground(background));
                }
            }
        },
        // gets the x, y, z world postion of the target point
        {
            procName: MessageEnum.UIGetWordPosition,
            actionFn: function (params) {
                var worldPos = Human.renderer.pick.pick(params.x, params.y, { rayPick: true }).worldPos;
                if (worldPos) {
                    var x = worldPos[0], y = worldPos[1], z = worldPos[2];
                    return { x: x, y: y, z: z };
                }
                else {
                    return null;
                }
            }
        },
        {
            procName: MessageEnum.UISetLoadingExperience,
            actionFn: function (loaderType) {
                if (!isEmpty(loaderType)) {
                    store.dispatch([
                        new ViewActions.SetLoaderType(loaderType),
                        new ViewActions.ToggleLoader(true)
                    ]);
                }
                else {
                    store.dispatch(new ViewActions.ToggleLoader(false));
                }
                return true;
            }
        },
        {
            procName: MessageEnum.UISetScrollCaptureMode,
            actionFn: function (scrollCaptureMode) {
                store.dispatch(new SetScrollMode(scrollCaptureMode));
                return true;
            }
        },
        // gets the display config
        {
            procName: MessageEnum.UIGetDisplay,
            actionFn: function () {
                var layout = store.selectSnapshot(ViewState.getLayout);
                var legacyDisplayInfo = {
                    audio: layout.audio.enable,
                    fullscreen: layout.fullscreen.enable,
                    help: layout.help.enable,
                    // these all map from Camera
                    nav: layout.camera.enable,
                    cameraMode: layout.camera.enable,
                    center: layout.camera.enable,
                    zoomIn: layout.camera.enable,
                    zoomOut: layout.camera.enable,
                    info: layout.column.enable || layout.drawer.enable,
                    // these all map from Media
                    playPause: layout.media.enable,
                    scrubber: layout.media.enable,
                    'scrubber.chapters': layout.media.enable,
                    tools: layout.tools.enable,
                    'tools-display': layout.tools.enable,
                    tour: layout.pagination.enable,
                    'tour.chapters': layout.pagination.enable,
                    objectTree: layout.search.enable,
                    // legacy
                    share: false,
                    dissect: false,
                    xray: false,
                    annotations: false,
                };
                return legacyDisplayInfo;
            }
        },
        // sets the display config
        {
            procName: MessageEnum.UISetDisplay,
            mapFnIn: function (params) {
                // get the current layout
                var layout = store.selectSnapshot(ViewState.getLayout);
                // upgrade params to reflect new widget semantics
                var commonConfig = WidgetWiring.convertAPIUIConfigToUIConfig(params);
                // create a new layout
                return WidgetWiring.createLayoutFromConfig(layout, commonConfig);
            },
            actionFn: function (layout) {
                // have our new layout take effect
                // noop for now
                store.dispatch(new ViewActions.SetLayout(layout));
            }
        },
        // resets the UI to the initial layout
        {
            procName: MessageEnum.UIResetDisplay,
            actionFn: function () {
                var initialLayout = store.selectSnapshot(ViewState.getInitialLayout);
                store.dispatch(new ViewActions.SetLayout(initialLayout));
            }
        },
        // take a snapshot of the current chapter
        {
            procName: MessageEnum.UISnapshot,
            aliases: [MessageEnum.SceneSnapshot],
            // normalize params: extend defaults
            mapFnIn: function (params) {
                var _a = engineService.getCanvas(), width = _a.width, height = _a.height;
                return __assign({ width: width, height: height, openInTab: false }, params);
            },
            actionFn: function (params) {
                var width = params.width, height = params.height, openInTab = params.openInTab;
                var currentChapterId = store.selectSnapshot(StoryChaptersState.getSelectedChapterId);
                var dimensions = { width: width, height: height };
                return store.dispatch(new TakeChapterPicture(currentChapterId, dimensions, true, true))
                    .pipe(
                // extract success
                flatMap(function () {
                    return actions.pipe(ofActionDispatched(TakeChapterPictureSuccess), take(1));
                }), 
                // serialize
                flatMap(function (e) { return imageService.blobToBase64(e.blob); }), 
                // open image tab: optional
                tap(function (imageData) {
                    if (openInTab && imageData) {
                        openImageInTab(imageData);
                    }
                }), 
                // handle errors: empty response
                catchError(function () { return of(null); }));
            }
        }
    ];
}
